/* ZENTO · LE EMOJI BELLE ANCHE SU WINDOWS (Mirco 19.10: "le icone su desktop Windows sono veramente brutte, usa quelle Apple").
   Le emoji di Apple non si possono usare su un sito (sono di Apple). Si usano le "Fluent 3D" di Microsoft, libere (licenza MIT)
   e molto simili. Su iPhone, iPad e Mac non si tocca niente: li le emoji sono gia quelle di Apple.
   Come funziona: si cercano le emoji nei testi della pagina (anche quelle che compaiono dopo, come i bollini dell'app) e si
   mettono al loro posto le immagini, alte quanto il testo. Se un'immagine non esiste, torna l'emoji normale. */
(function () {
  'use strict';
  if (window.__zrEmoji) return;
  window.__zrEmoji = true;
  var ua = navigator.userAgent || '';
  if (/Mac|iPhone|iPad|iPod/.test(ua) || /Mac/.test(navigator.platform || '')) return;

  var BASE = 'https://cdn.jsdelivr.net/npm/@lobehub/fluent-emoji-3d@1.1.0/assets/';
  var RE = /(?:\p{Extended_Pictographic}|[#*0-9]️?⃣)(?:️|‍\p{Extended_Pictographic}️?|[\u{1F3FB}-\u{1F3FF}])*/gu;
  var SALTA = {SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1, CODE: 1, PRE: 1, TITLE: 1};

  var stile = document.createElement('style');
  stile.textContent = '.zr-emo{display:inline-block;height:1.2em;width:1.2em;vertical-align:-.22em;margin:0 .05em;object-fit:contain}';
  document.head.appendChild(stile);

  function codice(e) {
    var out = [];
    for (var ch of e) out.push(ch.codePointAt(0).toString(16));
    return out.join('-');
  }
  // il nome del file: con o senza il "selettore" fe0f (le Fluent lo vogliono solo dove e d'obbligo)
  function alternativo(c) { return /-fe0f/.test(c) ? c.replace(/-fe0f/g, '') : c.split('-')[0] + '-fe0f' + (c.indexOf('-') > 0 ? c.slice(c.indexOf('-')) : ''); }

  function immagine(e) {
    var img = document.createElement('img');
    var c = codice(e);
    img.className = 'zr-emo';
    img.alt = e;
    img.draggable = false;
    img.decoding = 'async';
    img.src = BASE + c + '.webp';
    img.onerror = function () {
      if (!img.dataset.prova) { img.dataset.prova = '1'; img.src = BASE + alternativo(c) + '.webp'; return; }
      img.replaceWith(document.createTextNode(e)); // non esiste: torna l'emoji normale
    };
    return img;
  }

  function sistemaTesto(nodo) {
    var t = nodo.nodeValue;
    if (!t || !RE.test(t)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment(), da = 0, m;
    while ((m = RE.exec(t))) {
      if (/^[\d#*]$/.test(m[0])) continue; // un numero da solo non e un'emoji
      if (m.index > da) frag.appendChild(document.createTextNode(t.slice(da, m.index)));
      frag.appendChild(immagine(m[0]));
      da = m.index + m[0].length;
    }
    if (!da) return;
    if (da < t.length) frag.appendChild(document.createTextNode(t.slice(da)));
    nodo.parentNode.replaceChild(frag, nodo);
  }

  function scorri(radice) {
    if (!radice || (radice.nodeType === 1 && (SALTA[radice.nodeName] || radice.isContentEditable || radice.closest('svg')))) return;
    if (radice.nodeType === 3) { if (radice.parentNode && !SALTA[radice.parentNode.nodeName]) sistemaTesto(radice); return; }
    var w = document.createTreeWalker(radice, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SALTA[p.nodeName] || p.isContentEditable || (p.closest && p.closest('svg'))) return NodeFilter.FILTER_REJECT;
        return /[←-⯿\u{1F000}-\u{1FAFF}]/u.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });
    var lista = [];
    while (w.nextNode()) lista.push(w.currentNode);
    lista.forEach(sistemaTesto);
  }

  var coda = new Set(), timer = null;
  function svuota() { timer = null; coda.forEach(scorri); coda.clear(); }
  function avvia() {
    scorri(document.body);
    new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        var r = lista[i];
        if (r.type === 'characterData') coda.add(r.target);
        else r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.classList && n.classList.contains('zr-emo')) return; coda.add(n); });
      }
      if (coda.size && !timer) timer = setTimeout(svuota, 60);
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
